import { ReactNode, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import {
  closestCenter,
  DndContext,
  DragOverlay,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";

import { cardKeyboardCoordinates } from "../cardKeyboardCoordinates";
import { moveItem } from "../dashboardLayout";

export const TileMover = ({ keys, onMove, children }: { keys: string[]; onMove: (order: string[]) => void; children: ReactNode }) => {
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 6 } }),
    useSensor(KeyboardSensor, { coordinateGetter: cardKeyboardCoordinates }),
  );
  const [moving, setMoving] = useState<string | null>(null);

  useEffect(() => {
    if (moving === null) return;

    const keepEscapeToTheMove = (event: KeyboardEvent) => {
      if (event.key === "Escape") event.preventDefault();
    };
    window.addEventListener("keydown", keepEscapeToTheMove, true);
    return () => window.removeEventListener("keydown", keepEscapeToTheMove, true);
  }, [moving]);

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragStart={({ active }) => setMoving(String(active.id))}
      onDragCancel={() => setMoving(null)}
      onDragEnd={({ active, over }) => {
        setMoving(null);
        if (over) onMove(moveItem(keys, String(active.id), String(over.id)));
      }}
    >
      {children}
      {createPortal(
        <DragOverlay>
          {moving !== null && (
            <div className="inline-block rounded-lg border border-theme-border bg-theme-surface shadow-xl shadow-theme-shadow px-4 py-3 text-lg font-semibold text-theme-text cursor-grabbing">
              {moving}
            </div>
          )}
        </DragOverlay>,
        document.body
      )}
    </DndContext>
  );
};
